import { render, staticRenderFns } from "./AccessWalletCoolWallet.vue?vue&type=template&id=455a69ea&scoped=true&"
import script from "./AccessWalletCoolWallet.vue?vue&type=script&lang=js&"
export * from "./AccessWalletCoolWallet.vue?vue&type=script&lang=js&"
import style0 from "./AccessWalletCoolWallet.vue?vue&type=style&index=0&id=455a69ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455a69ea",
  null
  
)

export default component.exports